import navSessionTemplate from './json-interfaces/navigation.session.json';
import navEscalatedTemplate from './json-interfaces/navigation.cookieEscalated.json';
import navReactNativeReactTemplate from './json-interfaces/navigation.reactNativeReact.json';
import navReactNativeTemplate from './json-interfaces/navigation.reactNative.json';
import navReactNativeGCOTemplate from './json-interfaces/navigation.reactNativeGCO.json';
import navReactNativeProfileTemplate from './json-interfaces/navigation.reactNative-profile.json';
import navProfileTemplate from './json-interfaces/navigation.profile.json';
import navRequestAppVersionTemplate from './json-interfaces/navigation.requestAppVersion.json';
import navReactNativeLogoutPasswordTemplate from './json-interfaces/navigation.reactNative-logoutPassword.json';

function deepClone<T>(obj: T): T {
    return JSON.parse(JSON.stringify(obj));
}

function getNavigationJSON(type: string, url: string, data: any, title: string, id?: any, host?: boolean) {
    try {
        // clone templates to avoid cross-call mutations
        let jsonNavSession = deepClone(navSessionTemplate);
        let jsonNavEscalated = deepClone(navEscalatedTemplate);
        let jsonNavReactNativeReact = deepClone(navReactNativeReactTemplate);
        let jsonNavReactNative = deepClone(navReactNativeTemplate);
        let jsonNavReactNativeGCO = deepClone(navReactNativeGCOTemplate);
        let jsonNavReactNativeProfile = deepClone(navReactNativeProfileTemplate);
        let jsonNavProfile = deepClone(navProfileTemplate);
        let jsonNavRequestAppVersion = deepClone(navRequestAppVersionTemplate);
        let jsonNavReactNativeLogoutPassword = deepClone(navReactNativeLogoutPasswordTemplate);
        let jsonResults: any = {};

        delete (jsonNavReactNativeReact as any).data.topBar.rightButtons;
        switch (type) {
            //MODO FLOW
            case 'modeFlow-backgroundBlue': {
                if (Object.keys(data).length === 0) {
                    delete (jsonNavReactNativeReact as any).data.request.parameters;
                } else {
                    (jsonNavReactNativeReact as any).data.request.parameters = data;
                }
                (jsonNavReactNativeReact as any).data.request.endpointUrl = host
                    ? `${window.location.origin}${url}`
                    : url;
                (jsonNavReactNativeReact as any).data.mode = 'FLOW';
                (jsonNavReactNativeReact as any).data.topBar.title = title;
                (jsonNavReactNativeReact as any).data.topBar.backgroundColor = '#00008C';
                (jsonNavReactNativeReact as any).data.topBar.tintColor = '#FFFFFF';
                jsonResults = jsonNavReactNativeReact;
                break;
            }
            //MODO MODAL
            case 'modeModal-backgroundBlue': {
                if (Object.keys(data).length === 0) {
                    delete (jsonNavReactNativeReact as any).data.request.parameters;
                } else {
                    (jsonNavReactNativeReact as any).data.request.parameters = data;
                }
                (jsonNavReactNativeReact as any).data.request.endpointUrl = host
                    ? `${window.location.origin}${url}`
                    : url;
                (jsonNavReactNativeReact as any).data.topBar.title = title;
                (jsonNavReactNativeReact as any).data.mode = 'MODAL';
                (jsonNavReactNativeReact as any).data.topBar.backgroundColor = '#00008C';
                (jsonNavReactNativeReact as any).data.topBar.tintColor = '#FFFFFF';
                jsonResults = jsonNavReactNativeReact;
                break;
            }
            //MODO FEEDBACK
            case 'feedback-success': {
                (jsonNavReactNative as any).data.data.type = data.state;
                (jsonNavReactNative as any).data.data.title = data.title;
                (jsonNavReactNative as any).data.data.subtitle = data.subtitle;
                jsonResults = jsonNavReactNative;
                break;
            }
            case 'feedback-info': {
                (jsonNavReactNative as any).data.data.type = data.state;
                (jsonNavReactNative as any).data.data.title = data.title;
                (jsonNavReactNative as any).data.data.subtitle = data.subtitle;
                (jsonNavReactNative as any).data.data['codeProblem'] = data.codeProblem;
                jsonResults = jsonNavReactNative;
                break;
            }
            case 'feedback-error': {
                (jsonNavReactNative as any).data.data.type = data.state;
                (jsonNavReactNative as any).data.data.title = data.title;
                (jsonNavReactNative as any).data.data.subtitle = data.subtitle;
                (jsonNavReactNative as any).data.data['errorReference'] = data.errorCode;
                jsonResults = jsonNavReactNative;
                break;
            }
            // MODO MODAL WITH WHITE BACKGROUND
            case 'modeModal-backgroundWhite': {
                if (Object.keys(data).length === 0) {
                    delete (jsonNavReactNativeReact as any).data.request.parameters;
                } else {
                    (jsonNavReactNativeReact as any).data.request.parameters = data;
                }
                (jsonNavReactNativeReact as any).data.request.endpointUrl = host
                    ? `${window.location.origin}${url}`
                    : url;
                (jsonNavReactNativeReact as any).data.topBar.title = title;
                (jsonNavReactNativeReact as any).data.mode = 'MODAL';
                (jsonNavReactNativeReact as any).data.topBar.backgroundColor = '#FFFFFF';
                (jsonNavReactNativeReact as any).data.topBar.tintColor = '#00001E';
                jsonResults = jsonNavReactNativeReact;
                break;
            }
            //MODO FLOW WITH WHITE BACKGROUND
            case 'modeFlow-backgroundWhite': {
                if (Object.keys(data).length === 0) {
                    delete (jsonNavReactNativeReact as any).data.request.parameters;
                } else {
                    (jsonNavReactNativeReact as any).data.request.parameters = data;
                }
                (jsonNavReactNativeReact as any).data.request.endpointUrl = host
                    ? `${window.location.origin}${url}`
                    : url;
                (jsonNavReactNativeReact as any).data.topBar.title = title;
                (jsonNavReactNativeReact as any).data.topBar.backgroundColor = '#FFFFFF';
                (jsonNavReactNativeReact as any).data.topBar.tintColor = '#00001E';
                (jsonNavReactNativeReact as any).data.mode = 'FLOW';
                jsonResults = jsonNavReactNativeReact;
                break;
            }
            //FLOW WITH BUTTONS
            case 'fiber-test-speed': {
                if (Object.keys(data).length === 0) {
                    delete (jsonNavReactNativeReact as any).data.request.parameters;
                } else {
                    (jsonNavReactNativeReact as any).data.request.parameters = data;
                }
                (jsonNavReactNativeReact as any).data.request.endpointUrl = host
                    ? `${window.location.origin}${url}`
                    : url;
                (jsonNavReactNativeReact as any).data.mode = 'FLOW';
                (jsonNavReactNativeReact as any).data.topBar.title = title;
                (jsonNavReactNativeReact as any).data.topBar['rightButtons'] = [
                    { id: 'INFO_SPEED_TEST', imageName: 'information-user-regular' },
                ];
                jsonResults = jsonNavReactNativeReact;
                break;
            }
            //CALLDIVERT
            case 'callDivert': {
                if (Object.keys(data).length === 0) {
                    delete (jsonNavReactNativeReact as any).data.request.parameters;
                } else {
                    (jsonNavReactNativeReact as any).data.request.parameters = data;
                }
                (jsonNavReactNativeReact as any).data.request.endpointUrl = host
                    ? `${window.location.origin}${url}`
                    : url;
                (jsonNavReactNativeReact as any).data.mode = 'FLOW';
                (jsonNavReactNativeReact as any).data.topBar.title = title;
                (jsonNavReactNativeReact as any).data.topBar['rightButtons'] = [
                    { id: 'CALLDIVERT', imageName: 'information-user-regular' },
                ];
                jsonResults = jsonNavReactNativeReact;
                break;
            }
            //ORDERS
            case 'ordersInfo': {
                if (Object.keys(data).length === 0) {
                    delete (jsonNavReactNativeReact as any).data.request.parameters;
                } else {
                    (jsonNavReactNativeReact as any).data.request.parameters = data;
                }
                (jsonNavReactNativeReact as any).data.request.endpointUrl = host
                    ? `${window.location.origin}${url}`
                    : url;
                (jsonNavReactNativeReact as any).data.mode = 'MODAL';
                (jsonNavReactNativeReact as any).data.topBar.title = title;
                (jsonNavReactNativeReact as any).data.topBar['rightButtons'] = [
                    { id: 'ORDERS', imageName: 'question-regular' },
                ];
                jsonResults = jsonNavReactNativeReact;
                break;
            }
            //MODE EXTERNAL
            case 'modeExternal': {
                delete (jsonNavReactNativeReact as any).data.request.parameters;
                (jsonNavReactNativeReact as any).data.request.endpointUrl = url;
                (jsonNavReactNativeReact as any).data.mode = 'EXTERNAL';
                (jsonNavReactNativeReact as any).data.topBar.title = '';
                jsonResults = jsonNavReactNativeReact;
                break;
            }
            case 'download-bill-android': {
                delete (jsonNavReactNativeReact as any).data.request.parameters;
                (jsonNavReactNativeReact as any).data.request.base64 = data.base64;
                (jsonNavReactNativeReact as any).data.mode = 'DOWNLOAD_BILL';
                (jsonNavReactNativeReact as any).data.topBar.title = title;
                jsonResults = jsonNavReactNativeReact;
                break;
            }
            case 'download-bill': {
                delete (jsonNavReactNative as any).data.data.type;
                delete (jsonNavReactNative as any).data.data.title;
                delete (jsonNavReactNative as any).data.data.subtitle;
                const event = {
                    type: 'NAVIGATION_NATIVE',
                    data: {
                        id: 'PDF',
                        mode: 'MODAL',
                        topBar: {
                            title,
                            type: 'SHORT',
                            backgroundColor: '#00008C',
                            tintColor: '#FFFFFF',
                        },
                        data: { base64: data.base64 },
                    },
                };
                jsonResults = event;
                break;
            }
            //MODE BROWSER
            case 'modeBrowser': {
                delete (jsonNavReactNativeReact as any).data.request.parameters;
                (jsonNavReactNativeReact as any).data.request.endpointUrl = url;
                (jsonNavReactNativeReact as any).data.mode = 'BROWSER';
                (jsonNavReactNativeReact as any).data.topBar.title = title;
                (jsonNavReactNativeReact as any).data.topBar.backgroundColor = '#FFFFFF';
                (jsonNavReactNativeReact as any).data.topBar.tintColor = '#00001E';
                jsonResults = jsonNavReactNativeReact;
                break;
            }
            case 'modeBrowser-backgroundBlue': {
                delete (jsonNavReactNativeReact as any).data.request.parameters;
                (jsonNavReactNativeReact as any).data.request.endpointUrl = url;
                (jsonNavReactNativeReact as any).data.mode = 'BROWSER';
                (jsonNavReactNativeReact as any).data.topBar.title = title;
                (jsonNavReactNativeReact as any).data.topBar.tintColor = '#FFFFFF';
                (jsonNavReactNativeReact as any).data.topBar.backgroundColor = '#00008C';
                jsonResults = jsonNavReactNativeReact;
                break;
            }
            //MODE GCO
            case 'gco-navigation': {
                (jsonNavReactNativeGCO as any).data.data.endpointUrl = data.webviewUrl;
                (jsonNavReactNativeGCO as any).data.data.callBackUrl = data.callBackUrl;
                jsonResults = jsonNavReactNativeGCO;
                break;
            }
            //NAVIGATION GLOBAL PROFILE
            case 'navigation-global-profile': {
                if (Object.keys(data).length === 0) {
                    delete (jsonNavProfile as any).data.request.parameters;
                } else {
                    (jsonNavProfile as any).data.request.parameters = data;
                }
                (jsonNavProfile as any).data.request.endpointUrl = `${window.location.origin}/profile`;
                jsonResults = jsonNavProfile;
                break;
            }
            //MODE NAVIGATION NATIVE PROFILE
            case 'navigation-native-profile': {
                (jsonNavReactNativeProfile as any).data.id = id;
                (jsonNavReactNativeProfile as any).data.mode = 'FLOW';
                (jsonNavReactNativeProfile as any).data.topBar.title = title;
                jsonResults = jsonNavReactNativeProfile;
                break;
            }
            case 'navigation-native-critical-error': {
                (jsonNavReactNative as any).data.id = 'CRITICAL_ERROR';
                (jsonNavReactNative as any).data.mode = 'FULL_SCREEN';
                (jsonNavReactNative as any).data.data.id = `${data.id}`;
                (jsonNavReactNative as any).data.data.title = data.title;
                (jsonNavReactNative as any).data.data.localizedDescription = data.localizedDescription;
                (jsonNavReactNative as any).data.data.httpCode = data.httpCode;
                delete (jsonNavReactNative as any).data.data.type;
                delete (jsonNavReactNative as any).data.data.title;
                delete (jsonNavReactNative as any).data.data.subtitle;
                jsonResults = jsonNavReactNative;
                window.localStorage.clear();
                window.sessionStorage.clear();
                break;
            }
            case 'navigation-native-logout': {
                (jsonNavReactNative as any).data.id = 'LOGOUT_ALERT';
                (jsonNavReactNative as any).data.mode = 'FULL_SCREEN';
                delete (jsonNavReactNative as any).data.data;
                jsonResults = jsonNavReactNative;
                window.localStorage.clear();
                window.sessionStorage.clear();
                break;
            }
            case 'navigation-camera-permission': {
                (jsonNavReactNative as any).data.id = 'PERMISSIONS_REQUEST';
                (jsonNavReactNative as any).data.mode = 'FULL_SCREEN';
                (jsonNavReactNative as any).data.data.id = 'CAMERA';
                delete (jsonNavReactNative as any).data.data.type;
                delete (jsonNavReactNative as any).data.data.title;
                delete (jsonNavReactNative as any).data.data.subtitle;
                jsonResults = jsonNavReactNative;
                break;
            }
            case 'navigation-light-titular': {
                (jsonNavReactNative as any).data.id = 'USER_UPGRADE_ALERT';
                (jsonNavReactNative as any).data.mode = 'FULL_SCREEN';
                delete (jsonNavReactNative as any).data.data;
                jsonResults = jsonNavReactNative;
                window.localStorage.clear();
                window.sessionStorage.clear();
                break;
            }
            case 'navigation-refresh-cookie': {
                (jsonNavSession as any).data.data = data.data;
                jsonResults = jsonNavSession;
                break;
            }
            case 'navigation-synchronized-cookie': {
                (jsonNavEscalated as any).data.data = data.data;
                jsonResults = jsonNavEscalated;
                break;
            }
            case 'navigation-request-app-version': {
                jsonResults = jsonNavRequestAppVersion;
                break;
            }
            case 'navigation-native-change-password': {
                (jsonNavReactNativeLogoutPassword as any).data.data.title = data.title;
                (jsonNavReactNativeLogoutPassword as any).data.data.subtitle = data.subtitle;
                jsonResults = jsonNavReactNativeLogoutPassword;
                window.localStorage.clear();
                window.sessionStorage.clear();
                break;
            }
            default: {
                break;
            }
        }
        return JSON.stringify(jsonResults);
    } catch (error) {
        console.error(error);
    }
}

export default getNavigationJSON;
